import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_ExpertCalibration_Interface, ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-ExpertCalibrationEdit',
  templateUrl: './ExpertCalibrationEdit.component.html',
  styleUrls: ['./ExpertCalibrationEdit.component.scss']
})
export class ExpertCalibrationEditComponent implements OnInit {
  Token:String=""

  @Input() innerPersonRecord:Persone_List_Interface=Empty_Persone_List_Interface()
  @Output() OnBack_Expert_Calibration_Action = new EventEmitter<number>();

  constructor(
    private ExpertCalibration_Service:ExpertCalibrationService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
  ) { }

  OnSet_Expert_Calibration(){
    this.OnBack_Expert_Calibration_Action.emit(-1);
  }


  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.EditExpertCalibration=new FormGroup({
      id :new FormControl(),
      Area_Type:new FormControl(0,Validators.required),
      Response:new FormControl(null),
      Dsc:new FormControl(null),
    })


    this.Nav_Service.CheckValidPage(this.Token,20).subscribe(
      data=>{
        this.ExpertCalibration_Service.GetSingle(this.Token,this.innerPersonRecord.id).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Response().setValue(data.response)
            this.get_Form_Dsc().setValue(data.dsc)
            this.get_Form_Area_Type().setValue(data.area_type)

          },error=>{
            localStorage.clear()
            location.reload();

          }
        )

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }


  //#region  Form Add

  EditExpertCalibration:FormGroup;

  get_Form_Id(){
    return this.EditExpertCalibration.get('id') as FormControl;
  }

  get_Form_Area_Type(){
    return this.EditExpertCalibration.get('Area_Type') as FormControl;
  }

  get_Form_Response(){
    return this.EditExpertCalibration.get('Response') as FormControl;
  }

  get_Form_Dsc(){
    return this.EditExpertCalibration.get('Dsc') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewExpertCalibration(){

    if(Number(this.get_Form_Area_Type().value)==0)
    {
      this.Alertify_Service.ErrorMessage("Select the activity location.")
    }
    else{
      var Record:ExpertCalibration_Interface =Empty_ExpertCalibration_Interface()
      Record.id=this.innerPersonRecord.id
      Record.area_type=Number(this.get_Form_Area_Type().value)
      Record.response=this.get_Form_Response().value
      Record.dsc=this.get_Form_Dsc().value


      this.InProccessing=true
      this.ExpertCalibration_Service.EditExpertCalibration(Record,this.Token).subscribe(
        data=>{
          this.InProccessing=false
          this.Alertify_Service.SuccessMessage("Information saved successfully.")

        },error=>{
          localStorage.clear()
          location.reload();

        }
      )

    }

  }
}
